<template>
  <div :class="['preview-main', shareTypeFile && 'white-bg']">
    <van-nav-bar
      v-if="!shareTypeFile && !hideHeader"
      class="file-header preview-header preview-header-bgcolor"
    >
      <i v-if="!isOpenPlatformWithToken" slot="left" class="iconfont icon-back" @click="handleClose"/>
      <template slot="title">
        <span v-if="currentVersion && currentVersion.version && !currentVersion.current" class="v-num">V{{currentVersion.version}}</span>
        <span class="preview-item-title" @click="onTitleClick">{{currentVersion.name || item.name || ''}}</span>
      </template>
      <!-- 历史版本不显示操作 -->
      <template v-if="$route.params.module !== 'open_preview' && (!currentVersion || currentVersion.current)" slot="right">
        <i
          v-if="!university_account_status"
          :class="{iconfont: true, 'icon-share': true, disabled: shouldDisabledShare}"
          @click="handleShare"
        />
        <i
          class="iconfont icon-more"
          @click="onMenuClick"
        />
      </template>
    </van-nav-bar>
    <div :class="['preview-body', this.viewer]">
      <!-- 生成预览状态 -->
      <div v-if="(isGenerating || error || generatingStatus) && !$route.query.wps_edit" class="preview-viewer preview-generate">
        <div class="generate-info">
          <div v-if="errorMessage" class="preview-icon">
            <svg-icon cls="type-icon" icon="preview-error" />
            <span class="error-message">{{errorMessage}}</span>
          </div>
          <!-- <template v-else-if="!generatingStatus">
            <van-loading />
            <div v-if="shareTypeFile" class="generating-text">{{$t('share.file.loading')}}</div>
          </template>
          <template v-else-if="$route.query.file_id == item.id || shareTypeFile || true">
            <van-loading />
            <div class="generating-progress">
              <div class="generating-bar primary-bgcolor" :style="{width: percent + '%'}"></div>
            </div>
            <div v-if="shareTypeFile" class="generating-text">{{$t('share.file.loading')}}</div>
            <template v-else>
              <van-loading />
              <div class="generating-text">{{$t('preivew.generating')}}</div>
              <div class="generating-text-sub">{{$t('preivew.generating_sub')}}</div>
            </template>
          </template> -->
          <van-loading v-else />

          <div class="grenerate-control">
            <span v-if="reason === 'unknown' || reason === 'server_error'" class="btn" @click="handleRegenerate">
              {{$t('preview.regenerate')}}
            </span>

            <span v-if="(reason === 'unknown' || reason === 'server_error') && changeModeAvailable " class="btn" @click="handleSwitchMode">
              {{$t('preview.switchMode')}}
            </span>

            <span v-if="reason === 'network_error'" class="btn" @click="handleReflash">
              {{$t('preview.reflash')}}
            </span>

            <!-- <span v-if="permDownload && !hideDownloadBtn" class="btn" @click="handleDownload">
              {{$t('preview.download')}}
            </span>

            <span v-if="permDownload && isExternalShare && permSave" class="btn" @click.stop="handleSave">
              {{$t('base.saveTo', [product_name])}}
            </span> -->
          </div>
        </div>
      </div>
      <template v-else-if="!isGenerating && !error && ((viewer === 'pdf' && generatingStatus === 'generated') || !generatingStatus) && show && !$route.query.wps_edit">
        <image-swipe
          v-if="viewer === 'image'"
          :item="item"
          :previewInfo="previewInfo"
          :isFileSharing="isFileSharing"
          :scenario="scenario"
          :renderLimit="renderLimit"
          @state-change="handleChangeState"
          @image-swipe="handleImageSwipe"
        />
        <video-viewer
          v-else-if="viewer === 'video'"
          :previewInfo="previewInfo"
          :item="item"
          @video-error="handleVideoError"
        />
        <pdf-viewer
          v-else-if="viewer === 'pdf'"
          :previewInfo="previewInfo"
          :item="item"
          @state-changed="handlePdfStateChanged"
          @pressmove="handlePressMove"
        />
        <yqx-viewer
          v-else-if="viewer === 'yiqixie'"
          :item="item"
          :scenario="scenario"
        />
        <wps-viewer
          v-else-if="viewer === 'wps'"
          @state-changed="handleWpsStateChanged"
          :previewInfo="previewInfo"
          :item="item"
          :url="previewInfo.preview_url"
          :scenario="scenario"
        />
        <cad-viewer
          v-else-if="viewer === 'cad'"
          :previewInfo="previewInfo"
          :item="item"
        />
        <application-viewer
          v-else-if="['ngm','xmd'].includes(viewer)"
          :previewInfo="previewInfo"
          :item="item"
          :kind="viewer"
          :scenario="scenario"
        />
      </template>
      <template v-else-if="$route.query.wps_edit">
        <wps-edit
          :url="base_url + '/collab_edit/document/' + $route.query.file_id + `${$route.query.unique_name ? '?share_link_unique_name=' + $route.query.unique_name : ''}`"
        />
      </template>
    </div>
    <!-- version -->
    <van-popup
      class="version-list"
      v-model="showVersionList"
      position="bottom"
      :overlay="false"
    >
      <version-list
        :fileItem="item"
        :versions="fileVersions"
        @version-close="handleVersionClose"
      />
    </van-popup>
    <!-- version end -->
    <van-popup v-model="showCurrentItemTotalName"
    get-container=".preview-main"
    style="background-color: rgba(255, 255, 255, 0);top: 10%;transform: translate3d(-50%,0,0);">
      <div class="pop-title" style="border-radius:3px;color:#000;background-color:#fff;font-size:15px;padding:5px;">
        {{currentVersion.name || item.name || ''}}
      </div>
    </van-popup>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import openAjax from '@/utils/openAjax'
import {i18n} from '@/utils/i18n'
import { OPEN_FILE_INFO, OPEN_PREVIEW_TOKEN } from '@/config/open-api'
import {MARK_AS_USED, GET_SIBLING, VERSIONS_INFO, FILE_INFO_NEW, GET_SHARE_LINK_PASSWORD} from '@/config/api'
import {normalizeFile, setThumbIcon, isItemNeedsApproval, checkScannedFile} from '@/utils/fileUtils'
import PreviewCore from '@/utils/PreviewCore'
import config from '../../config'
import PreviewLog from '../../log/PreviewLog'
import {alert, openPlatformCallback} from '@/utils/common'
import ImageSwipe from './ImageSwipe'
import ImageViewer from './ImageViewer'
import VideoViewer from './VCloudPlayerViewer.vue'
import PdfViewer, {PdfState} from './PdfViewer'
import YqxViewer from './YqxViewer'
import WpsViewer, {WpsState} from './WpsViewer'
import CadViewer from './CadViewer'
import VersionList from '../preview/VersionList'
import ApplicationViewer from './ApplicationViewer'
import fileActions from '@/utils/fileActions'
import H5Scenario from '@/boot/h5Scenario'
import BLH5Preview from '@/bi/blH5Preview'
import PreviewTimer from '@/bi/previewTimer'
import WpsEdit from './WpsEdit'

export default {
  name: 'PreviewView',
  i18n,
  components: {
    ImageSwipe,
    ImageViewer,
    VideoViewer,
    PdfViewer,
    YqxViewer,
    VersionList,
    WpsViewer,
    CadViewer,
    ApplicationViewer,
    WpsEdit
  },
  props: {
    show: Boolean,
    fileItem: Object,
    shareTypeFile: Boolean,
    permSave: Boolean,
    uniqueName: String
  },
  data () {
    return {
      item: {},
      previewInfo: {},
      isGenerating: true,
      percent: 0,
      generatingStatus: '',
      error: null,
      reason: '',
      errorMessage: '',
      kind: '',
      viewer: '',
      previewTask: 0,
      changeModeAvailable: false,
      showVersionList: this.show && this.$route.query.tab === 'version',
      hideHeader: this.$route.query.hideHeader === '1',
      fileVersions: [],
      currentVersion: {},
      product_name: config.product_name,
      base_url: config.imageUrl,
      isExternalShare: this.$route.params.module === 'share',
      previewTimer: Object,
      timeStamp: 0,
      showCurrentItemTotalName: false,
      university_account_status: config.university_account_status
    }
  },
  computed: {
    isOpenPlatformWithToken () {
      return config.isOpenPlatformWithToken
    },
    permDownload () {
      const item = this.fileItem || this.item
      return item.permissions && item.permissions.includes('item_download') &&
      (this.generatingStatus || (this.error && !['item_is_deleted', 'permission_denied'].includes(this.error.representation_fail_reason))) &&
      this.reason !== 'file_deleted' &&
      this.reason !== 'encrypt_yiqixie' &&
      this.$route.params.module !== 'open_preview'
    },
    hideDownloadBtn () {
      return (config.h5_scenario && config.h5_scenario === H5Scenario.WX_APPLET) ||
       (this.error && this.error.representation_fail_reason === 'share_link_preview_download_limited') ||
       config.viewConfig.isH5HideShareLinkDownload
    },
    renderLimit () {
      return this.previewInfo.category === 'watermark_preview' || !this.permDownload || this.item.is_encrypted
    },
    scenario () {
      if (this.isExternalShare) {
        return 'share'
      } else {
        return this.$route.query.scenario
      }
    },
    shouldDisabledShare () {
      const { action_permissions } = this.item

      if (!(action_permissions && (action_permissions.includes('perm_share_to_colleague') || action_permissions.includes('perm_share')))) {
        return true
      } else {
        return false
      }
    },
    isFileSharing () {
      return this.scenario === 'share' && !!(this.$route.query.unique_name || this.fileItem)
    }
  },
  watch: {
    $route (to, from) {
      if (to.query.preview && !from.query.preview) {
        this.isGenerating = true
        this.error = null
        this.generatingStatus = ''
      }
      if (
        (to.query.file_id !== from.query.file_id && from.query.file_id) ||
        (from.params.module === 'share' && to.params.module === 'share' && from.query.wps_edit && !to.query.wps_edit && from.query.preview === 1 && !to.query.preview) ||
        (to.query.version !== from.query.version)
      ) {
        this.startPreview()
      }
      this.showVersionList = this.show && to.query.tab === 'version'
    },
    show (val, oldVal) {
      if (val && !oldVal) {
        this.startPreview()
      } else {
        this.item = {}
        this.currentVersion = {}
        this.fileVersions = []
        this.isGenerating = true
        this.error = null
        this.generatingStatus = ''
        this.viewer = ''
        this.previewTask = 0
        this.changeModeAvailable = false
        this.kind = ''
        this.errorMessage = ''
        this.reason = ''
        this.previewCore && this.previewCore.destroy()
      }
    },
    percent (val) {
      if (val === 100) {
        this.clearStatus()
      }
    },
    'store.actionState' (state) {
      const { action, id, name, is_frequently_used } = state
      /* eslint-disable eqeqeq */
      if (this.item.id != id && this.currentVersion.file_id != id) return
      /* eslint-enable eqeqeq */

      switch (action) {
        case 'rename':
          this.item.name = name
          this.currentVersion.name = name
          break

        case 'delete':
          this.handleClose()
          break

        case 'frequent':
          this.item.is_frequently_used = is_frequently_used
          this.currentVersion.is_frequently_used = is_frequently_used
          normalizeFile(this.item)
          break

        default:
          break
      }
    }
  },
  created () {
    this.previewTimer = PreviewTimer.createTimer()
    this.startPreview()
  },
  beforeDestroy () {
    this.previewCore && this.previewCore.destroy()
  },
  methods: {
    startPreview () {
      this.timeStamp = new Date().getTime()
      const isShareImage = this.$route.query.share_extension_category === 'image'
      const sigleShareImageItem = (config.externalShareResponse && config.externalShareResponse.process && config.externalShareResponse.process.item) || {}
      const isSigleShareImage = sigleShareImageItem.extension_category

      // 预览流程总调度
      // 分享场景,制造数据,跳过阻碍请求,不影响页面流程, 后续请求info信息,重新初始化initPreviewCore
      if (isShareImage || isSigleShareImage) {
        this.isFetching = false
        const imageItem = isShareImage ? {
          id: this.$route.query.file_id,
          extension_category: this.$route.query.share_extension_category
        } : sigleShareImageItem
        const imageRes = {
          success: true,
          item: imageItem
        }
        this.initPreviewCore(imageRes)
        this.beforeOpenFile()
      }
      this.fetchItemSibling().then(res => {
        this.isFetching = false
        if (res && res.success) {
          if (!isShareImage && !isSigleShareImage) {
            this.initPreviewCore(res)
            this.beforeOpenFile()
          } else {
            // 分享图片场景,已经初始化完成,仅赋值就行
            const item = res.sibling || res.item
            normalizeFile(item)
            this.item = item
          }
        }
      })
    },
    initPreviewCore: function (res) {
      const item = res.sibling || res.item
      if (!item) return
      normalizeFile(item)
      this.item = item
      if (this.previewCore) {
        this.previewCore.destroy()
      }
      this.previewCore = new PreviewCore({
        item,
        previewToken: res.previewToken,
        stateChangedCallback: this.handleChangeState,
        version: this.$route.query.version,
        scenario: this.scenario,
        unique_name: this.uniqueName
      })
    },
    beforeOpenFile: function () {
      let promiseBeforeOpen = Promise.resolve()
      if (this.scenario !== 'share' && !config.isOpenPlatformWithToken) {
        promiseBeforeOpen = this.fetchVersions()
      }

      promiseBeforeOpen.then(() => {
        const kind = this.getKind()
        if (kind === 'pdf') {
          this.previewTimer.start().then(canceled => {
            if (!canceled) {
              BLH5Preview.error('preview timeout!')
            }
          })
        }
        this.openFile(kind)
      })
    },
    handlePdfStateChanged: function (state) {
      if (state === PdfState.PSPDFKIT_SUCCEED) {
        this.previewTimer.cancel()
        PreviewLog.succeed(this.item.id, Math.max(0, new Date().getTime() - this.timeStamp))
      } else if (state === PdfState.PSPDFKIT_FAILED) {
        this.previewTimer.cancel()

        // pspdf预览失败后自动切换为pdfjs预览
        this.previewCore.previewFile({
          type: 'pdf_enc',
          notFirst: true
        })
      } else if (state === PdfState.PDFJS_SUCCEED) {
        PreviewLog.succeed(this.item.id, Math.max(0, new Date().getTime() - this.timeStamp))
        this.previewTimer.cancel()
      } else if (state === PdfState.PDFJS_FAILED) {
        this.previewTimer.cancel()
        PreviewLog.previewError(this.item.id, Math.max(0, new Date().getTime() - this.timeStamp), 'pspdfjs load failed')
      }
    },
    handleWpsStateChanged: function (state) {
      this.previewTimer.cancel()
      if (state === WpsState.SUCCEED) {
        PreviewLog.succeed(this.item.id, Math.max(0, new Date().getTime() - this.timeStamp))
      } else if (state === WpsState.FAILED) {
        PreviewLog.previewError(this.item.id, Math.max(0, new Date().getTime() - this.timeStamp), 'wps load failed')
      }
    },
    handleChangeState (data) {
      if (!this.show) return

      if (data.errorMessage) {
        const kind = this.getKind()
        if (data.reason && data.reason === 'not_support') {
          BLH5Preview.sum(BLH5Preview.EVENT_NOT_SUPPORT, 1)
          if (PreviewLog.needLog(kind)) {
            PreviewLog.notSupportError(this.item, kind, Math.max(0, new Date().getTime() - this.timeStamp))
          }
        } else {
          BLH5Preview.error(data.errorMessage)
          if (PreviewLog.needLog(kind)) {
            PreviewLog.transformError(this.item.id, Math.max(0, new Date().getTime() - this.timeStamp), data.errorMessage)
          }
        }
      }

      for (let key in data) {
        if (key in this) {
          this[key] = data[key]

          if (data.previewInfo && this.viewer === 'image' && !this.store.imgPreviewInfo.ids.includes(this.item.id)) {
            this.store.imgPreviewInfo.ids.push(this.item.id)
            this.store.imgPreviewInfo.items[this.item.id] = this.item
          }
        }
      }
    },
    fetchItemSibling (direction) {
      let file_id = this.$route.query.file_id || this.fileItem.id
      if (!file_id) return Promise.reject(false)
      const { is_more_share } = this.$route.query
      const { unique_name } = this.$route.params
      this.isFetching = true
      // 如果是开放平台token形式进来的，走不同的逻辑
      if (!config.isOpenPlatformWithToken) {
        let [sort_by, sort_direction] = this.store.sortInfo.split('_')
        sort_by = sort_by || undefined
        let url
        let data
        // wap分享文件
        if (this.fileItem && this.isExternalShare) {
          file_id = this.fileItem.id
        }
        if (this.isFileSharing || is_more_share === 1) { // 单文件分享请求 FILE_INFO
          const unique_name_final = unique_name || this.$route.query.unique_name
          url = `${FILE_INFO_NEW}?item_typed_id=file_${file_id}&scenario=share&unique_name=${unique_name_final}&enterprise_id=${this.$route.query.enterprise_id || config.enterprise_info_base.id || ''}`
        } else {
          url = GET_SIBLING
          if (this.scenario === 'share') {
            url += '?scenario=share'
          }
          data = {
            file_id,
            sort_by,
            sort_direction,
            extension_category: direction ? 'image' : undefined,
            type: direction || undefined
          }
        }
        return ajax({
          url,
          data,
          errorCallBack: () => {
            this.handleClose(null, this.$route.query.tab && this.$route.query.tab === 'version')
          }
        })
      } else {
        if (!file_id) return Promise.reject(false)
        let finalResult = {}
        // 获取预览token
        let previewTokenPromise = openAjax({
          url: OPEN_PREVIEW_TOKEN,
          data: {
            file_id,
            'period': 3600
          },
          errorCallBack: () => {
            this.handleClose(null, this.$route.query.tab && this.$route.query.tab === 'version')
          }
        }).then(res => {
          finalResult.previewToken = res.preview_token
          return finalResult
        })
        // 获取文件item
        let itemPromise = openAjax({
          url: OPEN_FILE_INFO(file_id),
          errorCallBack: () => {
            this.handleClose(null, this.$route.query.tab && this.$route.query.tab === 'version')
          }
        }).then(res => {
          finalResult.item = res
          finalResult.success = true
          return finalResult
        })

        return Promise.all([previewTokenPromise, itemPromise]).then(res => {
          return finalResult
        })
      }
    },
    fetchVersions () {
      const { id } = this.item
      if (id) {
        return ajax({
          url: `${VERSIONS_INFO}?file_id=${id}`
        }).then(res => {
          if (res && res.success) {
            this.fileVersions = res.file_versions.map(item => {
              item.permissions = item.permissions || []
              if (!item.current) {
                item.file_version_id = item.id
              }
              setThumbIcon(item)
              return item
            })
          }
          return Promise.resolve()
        })
      }

      return Promise.reject(false)
    },
    getKind () {
      let { extension_category, extension, id } = this.item
      const { version } = this.$route.query
      // 预览历史版本时 要用历史版本的kind
      let currentVersion = null
      /* eslint-disable eqeqeq */
      if (version) {
        currentVersion = this.fileVersions.find(item => item.id == version)
      } else if (this.fileVersions[0] && (id == this.fileVersions[0].file_id)) {
        // get first version infomation in case of receive new version
        currentVersion = this.fileVersions[0]
      }
      /* eslint-enable eqeqeq */

      if (currentVersion) {
        extension_category = currentVersion.extension_category
        extension = currentVersion.extension
      }

      this.currentVersion = currentVersion || {}

      return this.previewCore.getKind(extension, extension_category)
    },
    openFile (kind) {
      BLH5Preview.sum(BLH5Preview.EVENT_PREVIEW, 1)

      // 图片上一个下一个kind是一样的
      kind = kind || this.getKind()

      // mark as used before fetch generate info
      if (this.scenario !== 'share' && !config.isOpenPlatformWithToken) {
        this.markAsUsed()
      }

      if (kind) {
        this.previewCore.previewFile({
          kind
        })
      } else {
        this.isGenerating = false
        this.error = {
          status: 'not_support'
        }
      }
    },
    markAsUsed () {
      if (!this.$route.query.file_id) {
        return
      }

      ajax({
        url: MARK_AS_USED,
        data: {item_typed_id: `file_${this.$route.query.file_id}`},
        accept_all_errors: true
      })
    },
    fetchShareLinkPassword (unique_name) {
      return ajax({
        url: GET_SHARE_LINK_PASSWORD,
        data: {unique_name}
      }).then(json => {
        if (json && json.success) {
          return json
        }
        return false
      })
    },
    getShareLinkPwd (scenario, extParams) {
      if (scenario !== 'share') {
        return Promise.resolve(extParams)
      } else {
        return this.fetchShareLinkPassword(extParams.shareToken).then(json => {
          return Promise.resolve({...extParams, password: json.pass || ''})
        })
      }
    },
    handleDownload () {
      if (isItemNeedsApproval(this.item)) {
        alert(i18n.t('file.action.forbidden.encrypt'))
        return
      }
      let { version, unique_name } = this.$route.query

      let extParams = {}
      if (this.scenario) {
        extParams.scenario = this.scenario
        if (this.scenario === 'share') {
          extParams.shareToken = unique_name || this.$route.params.unique_name
        }
      }

      /* eslint-disable eqeqeq */
      if (version) {
        const currentVersion = this.fileVersions.find(item => item.id == version)
        extParams.version_id = currentVersion.id
        extParams.name = currentVersion.name
      } else {
        if (checkScannedFile(this.item)) {
          alert(i18n.t('file.scanned.downloadDisabled'))
          return
        }
      }
      /* eslint-enable eqeqeq */

      this.previewCore.markDownloadBtnClicked()
      this.getShareLinkPwd(this.scenario, extParams).then(extParams => {
        fileActions.downloadFile(this.item, extParams)
      })
    },
    handleSave () {
      this.$emit('toggle-save', this.item)
    },
    handleReflash () {
      window.location.reload()
    },
    handleRegenerate () {
      const options = {force_regenerate: true}
      if (this.kind !== 'pdf') {
        options.kind = this.kind
      }
      this.previewCore.previewFile(options)
    },
    handleSwitchMode () {
      this.previewCore.previewFile({change_mode: true})
    },
    handleVideoError () {
      this.error = {
        status: 'generating_failed', representation_fail_reason: 'media_not_support'
      }
      this.errorMessage = this.previewCore.translateErrorMsg('media_not_support')
    },
    clearStatus () {
      if (this.generatingStatus || this.isGenerating) {
        setTimeout(() => {
          this.generatingStatus = ''
          this.isGenerating = false
        }, 100)
      }
    },
    handleImageSwipe (item) {
      this.$router.replace({query: {...this.$route.query, file_id: item.id}})
      this.item = item

      let promiseBeforeOpen = Promise.resolve()

      if (this.scenario !== 'share' && !config.isOpenPlatformWithToken) {
        promiseBeforeOpen = this.fetchVersions()
      }

      promiseBeforeOpen.then(res => {
        this.kind = this.getKind()
      })
    },
    handleClose (e, closeVerion) {
      if (this.$route.params.module === 'open_preview') {
        openPlatformCallback('close')
        // window.parent.postMessage(JSON.stringify({type: 'close', from: 'fangcloud'}), config.openConfig.origin)
      } else {
        this.$emit('close-preview', null, closeVerion)
      }
    },
    handleShare () {
      // 当没有分享权限的时候不弹出 actionsheet, 图标置灰
      if (this.shouldDisabledShare) return
      this.$emit('share-item', this.item)
    },
    onMenuClick () {
      this.setState({actionSheet: {
        actionItem: this.item,
        actionFrom: 'preview'
      }})
    },
    handleVersionClose () {
      this.$emit('close-version')
    },
    handlePressMove (fold) {
      this.$emit('trigger-fold', fold)
    },
    onTitleClick () {
      this.showCurrentItemTotalName = !this.showCurrentItemTotalName
    },
    hiddenCurrentItemTotalName () {
      this.showCurrentItemTotalName = false
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.preview-main {
  display: flex;
  width: 100%;
  height: 100%;
  /* color: #fff; */
  flex-direction: column;

  &.white-bg {
    box-sizing: border-box;
    color: #b2b7ca;
    background-color: #fff;
    padding: 5px 0 0;

    & .preview-generate .generating-progress {
      background-color: #f5f6f9;
    }

    & .preview-generate .generating-text {
      color: #252e36;
    }

    & .preview-generate .btn {
      border-color: #e3e3e3;
      color: #747b93;
    }
  }

  & .v-num {
    display: inline-block;
    box-sizing: border-box;
    min-width: 26px;
    height: 18px;
    line-height: 17px;
    font-size: 13px;
    text-align: center;
    border: 1px solid #fff;
    transform: scale(.75);
  }

  & .van-icon {
    color: #fff;
  }

  & .van-nav-bar__left {
    height: 44px;
  }

  & .van-nav-bar__title {
    box-sizing: border-box;
    padding: 0 10px;
    color: white;
  }

  & .van-nav-bar__right {
    right: 12px;
    height: 44px;
  }

  & .preview-body {
    height: 100%;
    flex: 1 1 auto;
    overflow: hidden;
    position: relative;
    background-color: #fff;

    &.image {
      display: flex;
      flex-direction: column;
    }
  }

  & .preview-viewer {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;

    &.loading {
      height: 100%;

      & .preview-pdf-viewer {
        height: 100%;
      }

      & .pdf-loading {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -15px;
        margin-top: -15px;
      }
    }

    &.pdf-js {
      position: absolute;
      height: auto;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
    }
  }

  & .preview-generate {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    & .generate-info {
      width: 100%
    }

    & .van-loading {
      margin: 10px auto
    }

    & .type-icon {
      width: 80px;
      height: 80px;
      display: block;
      margin: 0 auto
    }

    & .generating-progress {
      width: 80%;
      margin: 0 auto 20px;
      height: 4px;
      /* background-color: rgba(255, 255, 255, .3); */
    }

    & .generating-bar {
      height: 4px;
    }

    & .grenerate-control {
      margin-top: 20px
    }

    & .generating-text {
      font-size: 16px;
      color: #e6e7e8
    }

    & .generating-text-sub {
      font-size: 14px;
    }

    & .error-message {
      display: inline-block;
      margin-bottom: 10px
    }

    & .btn {
      border: 1px solid #fff;
      min-width: 110px;
      text-align: center;
      margin: 0 3px 5px;
      color: #fff;
    }
  }
}
.van-popup{
  & .van-overlay {
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>
